import { BadRequestException } from '../services/exceptions'
import { get, post, put } from './http'
import { dateToHoursMinsSecs, millisecsToMinSecs } from '../modules/utilities'

export async function getEnums() {
    // console.log('lseApi.getEnums()')
    const response = await get(`/enums/get/`)
    if (response.status === 200)
        return await response.json()

    throw new BadRequestException((await response.json()).message)
}

export async function getLseCompanies() {
    const response = await get(`/lse/getLseCompaniesMeta/lseCompanies`)
    if (response.status === 200)
        return await response.json()

    throw new BadRequestException((await response.json()).message)
}

export async function getLseApptsMeta() {
    // console.log("lseApi.getLseApptsMeta");
    const response = await get(`/lse/getLseApptsMeta/lseAppts`)
    if (response.status === 200)
        return await response.json()

    throw new BadRequestException((await response.json()).message)
}

export async function getLsePeopleMeta() {
    // console.log("lseApi.getLsePeopleMeta");
    const response = await get(`/lse/getLsePeopleMeta/lsePeople`)
    if (response.status === 200)
        return await response.json()

    throw new BadRequestException((await response.json()).message)
}

export async function getLseEventsMeta() {
    // console.log("lseApi.getLseEventsMeta");
    const response = await get(`/lse/getLseEventsMeta/lseEvents`)
    if (response.status === 200)
        return await response.json()

    throw new BadRequestException((await response.json()).message)
}

export async function getLseEntity(companyNumber) {
    const response = await get(`/lse/getLseEntity/${companyNumber}`)
    if (response.ok) {
        let json = await response.json()
        return json
    }
    throw new BadRequestException((await response.json()).body)
}

export async function getPerson(companyName, personName) {
    // console.log('companyName:',companyName)
    // Gets officer ids for 350 person
    const response = await get(`/lse/getPerson/${companyName}/${personName}`)
    if (response.ok) {
        let json = await response.json()
        return json
    }
    throw new BadRequestException((await response.json()).body)
}

export async function importGoogleSheetsCompanies() {
    const title = "import GoogleSheets Companies"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/importGoogleSheetsCompanies`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on importGoogleSheetsCompanies');
}

// Added function to import advisers from Google Sheets, as part of the "Import All" function in the Developer Menu
export async function importGoogleSheetsAdvisers() {
    const title = "import GoogleSheets Advisers"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/importAdvisers`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on importGoogleSheetsAdvisers');
}

export async function importGoogleSheetsDictionary() {
    const title = "import GoogleSheets Dictionary"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/importGoogleSheetsDictionary`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on importGoogleSheetsDictionary');
}

export async function importFinnhub() {
    const title = "import from Finnhub"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/importFinnhub`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on importFinnhub');
}

export async function importCompaniesHouse() {
    const title = "import from Companies House"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/importCompaniesHouse`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on importCompaniesHouse');
}

export async function cookResources() {
    const title = "Cooking"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/cookResources`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on cookResources');
}

export async function goShopping() {
    const title = "Shopping"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/goShopping`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on goShopping');
}

export async function deduplicatePeople() {
    const title = "Deduplicate People"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/deduplicatePeople`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on deduplicatePeople');
}

export async function importAll() {
    const title = "Import All"
    const startDate = new Date()
    logStart(title)
    const response = await put(`/lse/importAll`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on importAll');
}

export async function importEvents() {
    const title = "Import Events"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/importEvents`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException(`Unknown error occured on ${title}`);
}

export async function meldResources() {
    const title = "Melding"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/meldResources`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on meldResources');
}

export async function cookNews() {
    const title = "cookingNews"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/cooknews`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on cooknews');
}

export async function getAppointments(run) {
    const title = run ? "Start GetAppointments" : "Stop GetAppointments"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/getAppointments/${run}`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on getAppointments');
}

export async function parse350ClubDir() {
    const title = "Parse 350Club Dir"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/parse350ClubDir`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on Parse350ClubDir');
}

export function startScheduledImport() {
    get(`/lse/startScheduledImport`)
}

export function stopScheduledImport() {
    get(`/lse/stopScheduledImport`)
}

export async function validateOfficerIds() {
    const title = "Validate Officer Ids"
    const startDate = new Date()
    logStart(title)
    const response = await post(`/lse/validateOfficerIdsAsync`)
    if (response.ok) {
        await report(response, title, startDate)
        return
    }
    throw new BadRequestException('Unknown error occured on validateOfficerIds');
}

async function report(response, title, startDate) {
    const info = (await response.json()).info
    info.forEach(element => { console.log(element) })

    const millisecs = (new Date()) - startDate
    const time = millisecsToMinSecs(millisecs)
    logEnd(`${title} (${time})`)
}

const logStart = title => logTime(`Start "${title}"`)
const logEnd = title => logTime(`End "${title}"`)

const logTime = info => {
    let time = dateToHoursMinsSecs(new Date())
    console.log(time += info)
}